import produce from "immer";
import { create } from "zustand";
import { persist } from "zustand/middleware";

// Permet de garder les inforamtions du collaborateur qui ont veut offboardé
// utilisé dans la derniere étape des taches, clé => related_to
export const useUserOffboarding = create(
    persist(
        (set) => ({
            user_offboarding: null,
            setUserOffboarding: (json) => {
                set(
                    produce((state) => {
                        state.user_offboarding = json;
                    })
                );
            },
        }),
        {
            name: "user_offboarding",
        }
    )
);
